import React, { useContext } from 'react';

import { media } from 'context';
import { Layout, Text } from 'ds';
import PromoCard from 'ds/WorkspaceCarousel/PromoCard';
import WorkspaceCarousel from 'ds/WorkspaceCarousel/WorkspacePromoCarousel';
import { ListingWorkspace } from 'shared';

import NearbyWorkspace from './NearbyWorkspace';

interface Props {
  workspaces: ListingWorkspace[];
}

const NearbyWorkspaces: React.FC<Props> = ({ workspaces }) => {
  const { md, lg, sm, isMobile } = useContext(media);

  const filteredWorkspaces = workspaces
    .filter(({ name, images }) => !!name && images.length > 0)
    .map(w => ({
      ...w,
      name: w.name || '',
      slug: w.slug || '',
      image: w.images[0]
    }));

  return (
    <Layout>
      <Text size={isMobile ? 'headline-md' : 'h5'} color="gray-900" scale align={isMobile ? 'center' : undefined}>
        {isMobile ? 'Explore our offices' : 'Explore similar offices'}
      </Text>
      {md || lg || sm ? (
        <Layout marginTop={32} flex position="relative" left={-12} width="calc(100% + 24px)">
          {workspaces.map(workspace => {
            const { name, slug, id } = workspace;

            if (name && slug) {
              return (
                <Layout width="33.33%" paddingX={12} key={id}>
                  <NearbyWorkspace workspace={workspace} />
                </Layout>
              );
            }

            return null;
          })}
        </Layout>
      ) : (
        <Layout marginTop={32} {...(isMobile && { flex: true, direction: 'column', gap: 40 })}>
          {isMobile ? (
            filteredWorkspaces.map(workspace => {
              return (
                <PromoCard
                  workspace={workspace}
                  isStb={false}
                  showSeePricing={false}
                  showMeetingRoomsAndSquareFeet={true}
                />
              );
            })
          ) : (
            <WorkspaceCarousel paginationEnabled={false} workspaces={filteredWorkspaces} />
          )}
        </Layout>
      )}
    </Layout>
  );
};
export default NearbyWorkspaces;
